import React from 'react'
import { Dialog, DialogActions, DialogContent, Typography, Box, DialogTitle } from '@mui/material'
import { Cancel } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles'
import { ActionButton } from '../../../components/action-buttons'
import { useTranslation } from '../../../hooks'

export const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints, props }) => ({
    modalIconContainer: {
      display: 'flex',
      justifyContent: 'center'
    },
    modalIcon: {
      color: palette.success.shade[50],
      fontSize: 48
    },
    modalErrorIcon: {
      color: palette.error.main,
      fontSize: 48
    },
    modalTitle: {
      textAlign: 'center',
      maxWidth: 400
    },
    modalContent: {
      textAlign: 'center',
      maxWidth: 400
    },
    modalButton: {
      width: '100%',
      backgroundColor: palette.primary.main,
      color: palette.primary.contrastText,
      margin: spacing(2),
      padding: spacing(0.5),
      '&:hover': {
        backgroundColor: palette.primary.dark
      }
    },
    modalPaper: {
      padding: 24
    }
  })
)

export const SkillBiteLoadErrorModal = ({ title, description, open, onClose, onGoToDetailPage }) => {
  const classes = useStyles()
  const { t } = useTranslation('skill_bite')

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.modalPaper
      }}
    >
      <>
        <Box className={classes.modalIconContainer}>
          <Cancel fontSize='large' className={classes.modalErrorIcon} />
        </Box>
        <DialogTitle className={classes.modalTitle} data-test='skill-bite-load-error-modal-title'>
          <Typography variant='h6'>{title}</Typography>
        </DialogTitle>
        <DialogContent className={classes.modalContent} data-test='skill-bite-load-error-modal-description'>
          <Typography>{description}</Typography>
        </DialogContent>
        <DialogActions data-test='skill-bite-load-error-modal-button' sx={{ justifyContent: 'end' }}>
          <ActionButton variant='neutral' fullWidth onClick={onGoToDetailPage} label={t('view_details_page')} />
        </DialogActions>
      </>
    </Dialog>
  )
}
